module.exports = __webpack_public_path__ + "img/测点_钢丝绳.a372d36e.png";